import { render } from "./EmployerRequests.vue?vue&type=template&id=2d7e436a&ts=true"
import script from "./EmployerRequests.vue?vue&type=script&lang=ts"
export * from "./EmployerRequests.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__